<template>
  <div class="content-block">
    <p class="content-block__label">{{ $t('detail_invoice_section') }}</p>

    <div class="content-block__context" :class="contextClass">
      <div v-if="invoiceNumber" class="block-text">
        <span>{{ $t('detail_invoice_number') }}</span>
        <span>{{ invoiceNumber }}</span>
      </div>
      <div v-if="invoiceCarrierRow" class="block-text">
        <span>{{ invoiceCarrierRow.label }}</span>
        <span>{{ invoiceCarrierRow.value }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  invoiceNumber: string | null
  invoiceCarrierRow: { label: string; value: string } | null
  contextClass?: string
  paddingBetweenRows?: boolean
}

defineOptions({
  name: 'InvoiceSection',
})

withDefaults(defineProps<Props>(), {
  contextClass: '',
  paddingBetweenRows: false,
})
</script>
